import subDays from 'date-fns/subDays';
import { formatDate } from 'helpers/date';
import type { ISelectProduct } from 'v2/interfaces/product/selectProduct';

export interface ILeadsFilter {
  date: string[];
  campaign_id: (string | number)[];
  affiliate_id: (string | number)[];
  abandonment: string;
  product_id: ISelectProduct[];
}

export const getInitialValues = (): ILeadsFilter => ({
  date: [formatDate(subDays(new Date(), 7), 'dd/MM/yyyy'), formatDate(new Date(), 'dd/MM/yyyy')],
  campaign_id: [],
  affiliate_id: [],
  abandonment: '',
  product_id: []
});

const initialValues: ILeadsFilter = getInitialValues();
export default initialValues;
